import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import { WeatherApiProvider } from './context/WeatherApiContext'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <WeatherApiProvider>
      <App />
    </WeatherApiProvider>
  </React.StrictMode>,
)

